// #tag: ADMIT CARDS API CLIENT
// #purpose: Dispatches API requests for paginated admit card listings, status filters, and specific hall tickets.
import { apiGet } from './client';
import type { AdmitCard } from '../types';
import type { PaginatedResponse } from './results';

export interface AdmitCardsQuery {
  q?: string;
  status?: string;
  examCategory?: string;
  page?: number;
  limit?: number;
}

function toQuery(params: Record<string, string | number | undefined>): string {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '' && value !== 'all') sp.set(key, String(value));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export function fetchAdmitCards(query: AdmitCardsQuery = {}): Promise<PaginatedResponse<AdmitCard>> {
  return apiGet(`/admit-cards${toQuery(query as Record<string, string | number | undefined>)}`);
}

export function fetchAdmitCardById(id: string): Promise<AdmitCard> {
  return apiGet(`/admit-cards/${id}`);
}
